import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Calendar panel art: a month header with two nav buttons over a 7x4 grid of
 * day cells. Five cells carry events, one is outlined as today.
 */

const COLUMN_X = [12, 32, 52, 72, 92, 112, 132]
const ROW_Y = [28, 44, 60, 76]

/** `row-col` keys for the cells that hold an event. */
const EVENT_CELLS = new Set(['0-2', '1-0', '1-4', '2-6', '3-5'])
const TODAY_CELL = '2-3'

export function CalendarArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect x={12} y={12} width={56} height={7} rx={3} fill="hsl(var(--foreground) / 0.25)" />
      <rect x={128} y={12} width={8} height={7} rx={2} fill="hsl(var(--foreground) / 0.15)" />
      <rect x={140} y={12} width={8} height={7} rx={2} fill="hsl(var(--foreground) / 0.15)" />
      {ROW_Y.map((y, row) =>
        COLUMN_X.map((x, col) => {
          const key = `${row}-${col}`
          if (key === TODAY_CELL) {
            return (
              <rect
                key={key}
                x={x}
                y={y}
                width={16}
                height={12}
                rx={3}
                fill="none"
                stroke="hsl(var(--primary))"
                strokeWidth="2"
                vectorEffect="non-scaling-stroke"
              />
            )
          }
          return (
            <rect
              key={key}
              x={x}
              y={y}
              width={16}
              height={12}
              rx={3}
              fill={
                EVENT_CELLS.has(key) ? 'hsl(var(--primary) / 0.7)' : 'hsl(var(--foreground) / 0.08)'
              }
            />
          )
        }),
      )}
    </svg>
  )
}
